(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["owl-countdown"] && !Shopify.designMode) return;
  try {
    /*
   * OWL — contador de la oferta: los segundos caen (rodillo con golpe) y el resto
   * gira (cubo 3D). Recalcula SIEMPRE desde Date.now(), nunca resta 1 en cada
   * vuelta: asi no se desfasa aunque el navegador frene los temporizadores de una
   * pestana en segundo plano.
   */
  (() => {
    if (customElements.get('owl-countdown')) return;

    // Gravedad: arranca lenta y acelera (easeInQuad).
    const CAE = 'cubic-bezier(0.11, 0, 0.5, 0)';
    // Frena al subir (easeOutQuad).
    const SUBE = 'cubic-bezier(0.5, 1, 0.89, 1)';
    // Giro del cubo: arranca y frena suave (easeInOutSine); asentarse, easeOutCubic.
    const GIRA = 'cubic-bezier(0.45, 0, 0.55, 1)';
    const ASIENTA = 'cubic-bezier(0.33, 1, 0.68, 1)';
    const EJE = (grados) => `translateZ(-0.5em) rotateX(${grados}deg) translateZ(0.5em)`;

    // OJO: cada fotograma declara la opacidad. Si falta al final, WAAPI la completa
    // con la del CSS (la capa b vale 0) y la cifra se apaga en el rebote.
    const ESTILOS = {
      // Rodillo: llega estirada por la velocidad, se aplasta al golpear (70 %) y rebota.
      rodillo: {
        entra: [
          { transform: 'translateY(-130%) scale(0.9, 1.3)', opacity: 0.5, offset: 0, easing: CAE },
          { transform: 'translateY(0) scale(0.95, 1.12)', opacity: 1, offset: 0.58 },
          { transform: 'translateY(3%) scale(1.1, 0.84)', opacity: 1, offset: 0.7, easing: SUBE },
          { transform: 'translateY(-6%) scale(0.98, 1.05)', opacity: 1, offset: 0.85, easing: CAE },
          { transform: 'translateY(0) scale(1, 1)', opacity: 1, offset: 1 },
        ],
        sale: [
          { transform: 'translateY(0) scale(1, 1)', opacity: 1, easing: CAE },
          { transform: 'translateY(125%) scale(0.92, 1.2)', opacity: 0 },
        ],
        duracion: 540,
        duracionSale: 240,
        golpe: 0.58,
      },
      // Cubo: la cara nueva viene de arriba girando hacia el cliente; pasa 9 grados y
      // vuelve (rebote corto) antes de quedarse de frente.
      cubo: {
        entra: [
          { transform: EJE(90), opacity: 0.35, offset: 0, easing: GIRA },
          { transform: EJE(-9), opacity: 1, offset: 0.62, easing: ASIENTA },
          { transform: EJE(3), opacity: 1, offset: 0.84, easing: ASIENTA },
          { transform: EJE(0), opacity: 1, offset: 1 },
        ],
        sale: [
          { transform: EJE(0), opacity: 1, offset: 0, easing: GIRA },
          { transform: EJE(-99), opacity: 0.2, offset: 0.62, easing: ASIENTA },
          { transform: EJE(-87), opacity: 0.2, offset: 0.84 },
          { transform: EJE(-90), opacity: 0, offset: 1 },
        ],
        duracion: 620,
        duracionSale: 620,
        golpe: 0,
      },
    };

    class OwlCifra {
      constructor(el, caja) {
        this.estilo = ESTILOS[el.dataset.estilo] || ESTILOS.cubo;
        this.a = el.querySelector('.owl-cifra__a');
        this.b = el.querySelector('.owl-cifra__b');
        this.caja = caja;
        this.golpeLuz = caja.querySelector('.owl-countdown__golpe');
        this.valor = this.a.textContent.trim();
        this.objetivo = this.valor;
        this.ocupado = false;
      }

      mostrar(v) {
        this.valor = v;
        this.objetivo = v;
        this.a.textContent = v;
        this.b.textContent = v;
      }

      async cambiar(v) {
        const E = this.estilo;
        this.b.textContent = v;
        const entra = this.b.animate(E.entra, { duration: E.duracion, fill: 'forwards' });
        const sale = this.a.animate(E.sale, { duration: E.duracionSale, fill: 'forwards' });
        if (E.golpe) this.golpear(E.golpe, E.duracion);
        try {
          await entra.finished;
        } catch (e) {}
        // En el mismo turno: la capa de reposo toma la cifra nueva y todo vuelve.
        this.a.textContent = v;
        this.valor = v;
        entra.cancel();
        sale.cancel();
      }

      // El golpe del rodillo: linea de luz en la base y la baldosa cede hacia abajo.
      golpear(g, dur) {
        if (this.golpeLuz) {
          this.golpeLuz.animate(
            [{ opacity: 0 }, { opacity: 0, offset: g }, { opacity: 0.9, offset: g + 0.06 }, { opacity: 0 }],
            { duration: dur + 160 }
          );
        }
        this.caja.animate(
          [
            { transform: 'translateY(0)' },
            { transform: 'translateY(0)', offset: g },
            { transform: 'translateY(0.7cqi)', offset: g + 0.08, easing: ASIENTA },
            { transform: 'translateY(0)' },
          ],
          { duration: dur + 120 }
        );
      }

      ir(v) {
        this.objetivo = v;
        if (!this.ocupado) this.correr();
      }

      async correr() {
        this.ocupado = true;
        while (this.valor !== this.objetivo) await this.cambiar(this.objetivo);
        this.ocupado = false;
      }
    }

    class OwlCountdown extends HTMLElement {
      connectedCallback() {
        this.fin = Number(this.dataset.fin) * 1000;
        if (!this.fin) return;
        this.cajas = [...this.querySelectorAll('.owl-countdown__caja')];
        this.cifras = [...this.querySelectorAll('.owl-cifra')].map((el) => new OwlCifra(el, el.closest('.owl-countdown__caja')));
        this.seps = [...this.querySelectorAll('.owl-countdown__sep')];
        this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.alVolver = () => {
          if (!document.hidden) this.tick(true);
        };
        document.addEventListener('visibilitychange', this.alVolver);
        // Al cargar, las cifras quedan en la hora correcta sin animar.
        this.tick(true);

        // Destello: el puntero se lee en pointermove y se escribe una vez por cuadro.
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.alMover = (e) => {
            this.puntero = [e.clientX, e.clientY];
            if (!this.cuadro) this.cuadro = requestAnimationFrame(() => this.alumbrar());
          };
          this.addEventListener('pointermove', this.alMover);
          this.addEventListener('pointerenter', () => this.classList.add('is-alumbrado'));
          this.addEventListener('pointerleave', () => this.classList.remove('is-alumbrado'));
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.timerFin);
        cancelAnimationFrame(this.cuadro);
        document.removeEventListener('visibilitychange', this.alVolver);
      }

      alumbrar() {
        this.cuadro = 0;
        if (!this.puntero || this.reducido.matches) return;
        const [x, y] = this.puntero;
        for (const caja of this.cajas) {
          const r = caja.getBoundingClientRect();
          caja.style.setProperty('--owl-px', `${Math.round(x - r.left)}px`);
          caja.style.setProperty('--owl-py', `${Math.round(y - r.top)}px`);
        }
      }

      tick(quieto) {
        clearTimeout(this.timer);
        const resta = Math.max(0, Math.floor((this.fin - Date.now()) / 1000));
        const dos = (n) => String(n).padStart(2, '0').slice(-2);
        const cadena =
          dos(Math.floor(resta / 86400)) +
          dos(Math.floor((resta % 86400) / 3600)) +
          dos(Math.floor((resta % 3600) / 60)) +
          dos(resta % 60);
        const sinMover = quieto || this.reducido.matches || document.hidden;

        // De derecha a izquierda: si cambian varias, caen en cascada.
        let orden = 0;
        for (let k = this.cifras.length - 1; k >= 0; k--) {
          const c = this.cifras[k];
          const v = cadena[k];
          if (c.objetivo === v) continue;
          if (sinMover) {
            if (c.ocupado) c.objetivo = v;
            else c.mostrar(v);
            continue;
          }
          c.objetivo = v;
          const retraso = orden++ * 70;
          if (retraso) setTimeout(() => c.ir(v), retraso);
          else c.ir(v);
        }

        if (!sinMover) {
          for (const sep of this.seps) {
            sep.animate([{ opacity: 1 }, { opacity: 0.3, offset: 0.35 }, { opacity: 1 }], {
              duration: 800,
              easing: 'ease-in-out',
            });
          }
        }

        if (resta <= 0) {
          // Deja ver el ultimo golpe a cero y se desvanece; el guardia de
          // layout/theme.liquid recarga la pagina.
          this.timerFin = setTimeout(() => this.classList.add('is-terminado'), 900);
          return;
        }
        // Al siguiente cambio de segundo, no a "1000 ms desde ahora".
        this.timer = setTimeout(() => this.tick(false), 1000 - (Date.now() % 1000) + 20);
      }
    }

    customElements.define('owl-countdown', OwlCountdown);
  })();
  } catch(e) { console.error(e); }
})();

})();
